// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ebd73787","667":"2f453bed"}[chunkId] + ".chunk.js";
};